/// <amd-module name="Artifacts/FeedSettings/helpers/PermissionValidator" />
import * as Res from "Artifacts/FeedSettings/Resources";
import { FeedPermission } from "Artifacts/Root/web-apis/contracts/Feed";
import * as StringUtils from "VSS/Core/Util/String";

export function validatePermissions(
  exisitingPermissions: FeedPermission[],
  permissionsToAdd: FeedPermission[],
): string | null {
  if (permissionsToAdd == null) {
    // last identity got removed, re-render so Add button will be disabled
    return null;
  }

  // instead of 2 doing loops to check whether new identities already exists
  // create a set with incoming permissions and loop through existing ones
  const addPermissionSet = new Set<string>();
  permissionsToAdd.forEach((permission: FeedPermission) => {
    addPermissionSet.add(permission.identityId);
  });

  const displayNamesOfExistingPermission: string[] = [];

  // check first in existing permissions, capture them
  exisitingPermissions.forEach((existingPermission: FeedPermission) => {
    const permissionExists = addPermissionSet.has(existingPermission.identityId);
    if (permissionExists === false) {
      return;
    }

    // these identities already exist in grid
    displayNamesOfExistingPermission.push(existingPermission.displayName);
  });

  // get error message with display names of existing identities to show to user
  if (displayNamesOfExistingPermission.length > 0) {
    const displayNames: string = displayNamesOfExistingPermission.join(", ");
    return StringUtils.format(Res.Error_FeedSettings_PermissionAlreadyExists, displayNames);
  }

  // new identity was added, re-render so Add button will be enabled
  return null;
}
